module.exports = __webpack_public_path__ + "img/cement-batcher.39add70b.png";